import widgets from '../../../widgets';
import icons from '../../../../icons';
import { targetStateButton } from './targetStateButton';
import { getDefaultTargetState } from '../fsm_utils';
import { targetStateEditModal } from './targetStateEditModal';
import { TooltipKey } from '../../../machinelogic_tooltips';

/**
 * @typedef {Object} TargetState
 * @property {string} eventDefinition the event definition uuid|value or mqtt topic
 * @property {(mqtt|digital_input)} eventType the event type. Either mqtt or digital_input
 * @property {string} guardExpression the guard expression
 * @property {string} stateName the state name
 */

/**
 * @typedef {Object} State
 * @property {string} stateName the state name
 * @property {string} actionSequenceName the name of the sequence to run when this state is active
 * @property {TargetState[]} targetStates list of target transition states
 */

/**
 * returns a widget containing the target transition states for a specific fsm state
 * @param {Object} params
 * @param {TargetState[]} params.targetStates a list of target transition states for the current fsm state
 * @param {State[]} params.states a list of all fsm states
 * @param {() => void} params.onAddTargetState callback for a target transition state being added
 * @param {() => void} params.onTargetStateChange callback for a target transition state changing
 * @param {Object} params.library the library object
 * @returns {JQuery<HTMLElement>}
 */
export const targetStatesWidget = ({ targetStates, states, onAddTargetState, onTargetStatesChange, library }) => {
  const lDiv = widgets.baseWidget('Next States', false, { tooltipKey: TooltipKey.FSM_NEXT_STATE });
  const lContainerCollapsed = $('<div>').addClass('ml_fsm_target_states');
  const lEditStateModalBackground = $('<div>').addClass('ml_fsm_modal_background');
  const lEditStateModal = $('<div>').addClass('ml_fsm_target_state_expanded');
  const lAddTargetStateButton = $('<div>')
    .addClass('ml_fsm_target_state_adder')
    .append($('<i>')
      .addClass(icons.plusRaw))
    .on('click', () => {
      targetStateEditModal({
        targetState: getDefaultTargetState(states),
        states: states,
        library,
        onEditTargetStateDone: (pNewTargetState) => { onAddTargetState(pNewTargetState); }
      });
    });

  const lTargetStates = targetStates.map((pTargetState, pTargetStateIndex) => targetStateButton({
    modalBackground: lEditStateModalBackground,
    modal: lEditStateModal,
    targetState: pTargetState,
    states,
    library,
    onDeleteTargetState: () => {
      targetStates.splice(pTargetStateIndex, 1);
      onTargetStatesChange(targetStates);
    },
    onEditTargetStateDone: (pNewTargetState) => {
      targetStates[pTargetStateIndex] = pNewTargetState;
      onTargetStatesChange(targetStates);
    }
  }));

  return lDiv.append(
    lContainerCollapsed.append(
      lTargetStates,
      lAddTargetStateButton,
      lEditStateModalBackground.append(lEditStateModal)
    )
  );
};
